import type { GooglePlaceFields } from "@albertine/types";

export const GooglePlaceIdUpdateFields: GooglePlaceFields = [
    "id",
    "displayName",
    "googleMapsUri",
    "types",
    "businessStatus",
    "priceLevel",
    "servesLunch",
    "servesDinner",
    "servesBreakfast",
    "servesBrunch",
    "liveMusic",
    "primaryType",
    "location",
    "reservable",
];

export const GooglePlaceBatchUpdateFields: GooglePlaceFields = [
    ...GooglePlaceIdUpdateFields,
    "internationalPhoneNumber",
    "websiteUri",
    "formattedAddress",
    "addressComponents",
];

export const GooglePlaceFieldsNewCatalogItem: GooglePlaceFields = [
    ...GooglePlaceBatchUpdateFields,
    "userRatingCount",
    "rating",
    "photos",
];

export const GooglePlaceFieldsWebItem: GooglePlaceFields = [
    "id",
    "types",
    "formattedAddress",
    "internationalPhoneNumber",
    "websiteUri",
    "googleMapsUri",
    "businessStatus",
    "rating",
    "userRatingCount",
    "photos",
    "location",
    "viewport",
];

export const GooglePlaceLocationSearchFields: GooglePlaceFields = [
    "id",
    "addressComponents",
    "location",
    "displayName",
];
